import { computed, ComputedRef, defineAsyncComponent } from 'vue';
import type { Component } from 'vue';
import pageStore from '@/shared/content/page.store';

const components: ComponentIdentifiers = {
    B2B: {
        MiniBasket: defineAsyncComponent(() => import(/* webpackChunkName: 'B2BLayout', webpackPrefetch: true */ '@/b2b/shared/checkout/ui/MiniBasket.vue')),
        PageFooter: defineAsyncComponent(() => import(/* webpackChunkName: 'B2BLayout', webpackPrefetch: true */ '@/b2b/layout/footer/PageFooter.vue')),
        TopNavigation: undefined,
        ProductWishlist: defineAsyncComponent(() => import(/* webpackChunkName: 'B2BLayout', webpackPrefetch: true */ '@/b2b/product/ui/ProductWishlist.vue')),
    },
    B2C: {
        MiniBasket: defineAsyncComponent(() => import(/* webpackChunkName: 'B2CLayout', webpackPrefetch: true */ '@/b2c/shared/checkout/ui/MiniBasket.vue')),
        PageFooter: defineAsyncComponent(() => import(/* webpackChunkName: 'B2CLayout', webpackPrefetch: true */ '@/b2c/layout/footer/PageFooter.vue')),
        TopNavigation: undefined,
        ProductWishlist: defineAsyncComponent(() => import(/* webpackChunkName: 'B2CLayout', webpackPrefetch: true */ '@/b2c/product/wishlist/ui/ProductWishlist.vue')),
    },
    StoreContext: {
        MiniBasket: defineAsyncComponent(() => import(/* webpackChunkName: 'StoreContextLayout', webpackPrefetch: true */ '@/storecontext/shared/checkout/ui/MiniBasket.vue')),
        PageFooter: defineAsyncComponent(() => import(/* webpackChunkName: 'StoreContextLayout', webpackPrefetch: true */ '@/storecontext/layout/footer/PageFooter.vue')),
        TopNavigation: defineAsyncComponent(() => import(/* webpackChunkName: 'StoreContextLayout', webpackPrefetch: true */ '@/storecontext/navigation/TopNavigation.vue')),
        ProductWishlist: undefined,
    },
};

export function useBusinessComponent(name: ComponentIdentifier): ComputedRef<Component | undefined> {
    return computed(() => {
        let business;
        if (pageStore.isB2BPageLayout) {
            business = 'B2B';
        } else if (pageStore.isB2CPageLayout) {
            business = 'B2C';
        } else if (pageStore.isStoreContextPageLayout) {
            business = 'StoreContext';
        }
        return business ? components[business][name] : undefined;
    });
}

export type Business = 'B2B' | 'B2C' | 'StoreContext';
export type ComponentIdentifier = 'MiniBasket' | 'PageFooter' | 'TopNavigation' | 'ProductWishlist';
export type ComponentIdentifiers = Record<Business, Record<ComponentIdentifier, Component | undefined>>;
